import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Penggunaan Fitur"),
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted mt-6" })
], -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Status Penggunaan")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-auto fs-6 pt-4" }, " Konfigurasikan Penggunaan Fitur ", -1)
const _hoisted_11 = {
  key: 0,
  class: "btn btn-sm btn-secondary col col-lg-2",
  type: "button",
  style: {"width":"75px"},
  disabled: ""
}
const _hoisted_12 = {
  key: 1,
  class: "btn btn-sm btn-secondary col col-lg-2",
  type: "button",
  style: {"width":"125px"},
  disabled: ""
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_14 = { class: "container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Transaksional")
], -1)
const _hoisted_18 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_19 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_20 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Tagihan Digital", -1)
const _hoisted_25 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_26 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_27 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Pembayaran Otomatis", -1)
const _hoisted_31 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_32 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_33 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Auto Block Transaksi", -1)
const _hoisted_37 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_38 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_39 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_42 = { class: "container" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Layanan Berbayar")
], -1)
const _hoisted_46 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_47 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_48 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Top Up Manual", -1)
const _hoisted_53 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_54 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_55 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Custom Aplikasi", -1)
const _hoisted_59 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_60 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_61 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "PPDB", -1)
const _hoisted_65 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_66 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_67 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_70 = { class: "container" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_72 = { class: "row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Absensi")
], -1)
const _hoisted_74 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_75 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_76 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Absensi", -1)
const _hoisted_81 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_82 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_83 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Absensi Wajah", -1)
const _hoisted_87 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_88 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_89 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_92 = { class: "container" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_94 = { class: "row" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Layanan Pendukung")
], -1)
const _hoisted_96 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_97 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_98 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_101 = { class: "row" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Kalender Akademik", -1)
const _hoisted_103 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_104 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_105 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Jadwal Pelajaran", -1)
const _hoisted_109 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_110 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black  !important"}
}
const _hoisted_111 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-1" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end py-2 px-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              (_ctx.statusAllFitur == true)
                ? (_openBlock(), _createElementBlock("button", _hoisted_11, " Aktif "))
                : (_openBlock(), _createElementBlock("button", _hoisted_12, " Tidak Aktif "))
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                (_ctx.statusTransaksional == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_20, " Tidak Aktif "))
              ]),
              _hoisted_21
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                (_ctx.detailFiturSekolah.digitalInvoice == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_26, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_27, " Tidak Aktif "))
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                (_ctx.detailFiturSekolah.automaticPayment == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_32, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_33, " Tidak Aktif "))
              ]),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                (_ctx.detailFiturSekolah.blockCardTransaction == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_38, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_39, " Tidak Aktif "))
              ]),
              _hoisted_40
            ]),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                (_ctx.statusLayananBerbayar == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_47, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_48, " Tidak Aktif "))
              ]),
              _hoisted_49
            ]),
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                (_ctx.topUpManual.topUpManual == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_54, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_55, " Tidak Aktif "))
              ]),
              _hoisted_56
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                (_ctx.customApps.customApps == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_60, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_61, " Tidak Aktif "))
              ]),
              _hoisted_62
            ]),
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("div", _hoisted_65, [
                (_ctx.detailFiturSekolah.ppdb == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_66, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_67, " Tidak Aktif "))
              ]),
              _hoisted_68
            ]),
            _hoisted_69
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createElementVNode("div", _hoisted_74, [
                (_ctx.statusAbsensi == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_75, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_76, " Tidak Aktif "))
              ]),
              _hoisted_77
            ]),
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("div", _hoisted_81, [
                (_ctx.detailFiturSekolah.attendance == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_82, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_83, " Tidak Aktif "))
              ]),
              _hoisted_84
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("div", _hoisted_87, [
                (_ctx.detailFiturSekolah.faceRecognition == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_88, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_89, " Tidak Aktif "))
              ]),
              _hoisted_90
            ]),
            _hoisted_91
          ]),
          _createElementVNode("div", _hoisted_92, [
            _hoisted_93,
            _createElementVNode("div", _hoisted_94, [
              _hoisted_95,
              _createElementVNode("div", _hoisted_96, [
                (_ctx.statusLayananPendukung == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_97, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_98, " Tidak Aktif "))
              ]),
              _hoisted_99
            ]),
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                (_ctx.detailFiturSekolah.calendarAcademic == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_104, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_105, " Tidak Aktif "))
              ]),
              _hoisted_106
            ]),
            _createElementVNode("div", _hoisted_107, [
              _hoisted_108,
              _createElementVNode("div", _hoisted_109, [
                (_ctx.detailFiturSekolah.scheduleAcademic == true)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_110, " Aktif "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_111, " Tidak Aktif "))
              ]),
              _hoisted_112
            ]),
            _hoisted_113
          ])
        ]),
        _hoisted_114
      ])
    ])
  ], 64))
}